//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'SideBar',
  components: {
  },
  props: {
    activePage: String
  },
  computed: {
    dragOptions() {
        return {
            
        };
    }
  },
    data() {
        return {
            profilePicture: '',
            userName: '',
            multipleProfiles: '',
            loading: false
        }
    },
    mounted() {
        const axios = require('axios');
        this.profilePicture = this.$auth.user.profilePicture;
        this.userName = this.$auth.user.firstname + ' ' + this.$auth.user.lastname;
        var url = "https://api.eezywork.nl/v1/companies/profile/get-all.php?userId="+this.$auth.user.uid;
        axios.get(url)
        .then(response => {
            this.multipleProfiles = response.data.length;
            // console.log(this.profiles)
        })
        .catch(error => {
            // console.log(error.response)
        });
    },
  methods: {
      async logOut(){
        await this.$auth.logout();
        this.$router.push('/login');
      },
      switchProfile(){
        this.$router.push('/login/profielen');
      },
      startLoading(){
        this.loading = true;
        this.$emit("disable");
      },
      endLoading(){
        this.loading = false;
        this.$emit("enable");
    },
      activateTab(i){
        this.selected = i;
    },
  }
}
